import { gsap, Power2 } from "gsap";
function animateTextCustom(element, duration) {
    duration = duration || 1; // 如果未提供持续时间参数，则默认为 1 秒
  
    const items = element.children;
    const icon = element.querySelector(".custom-icon");
    const spans = Array.from(items).filter(
      (item) => item.tagName.toLowerCase() === "span"
    );
  
    if (spans.length && spans[0].classList.contains("animated")) return;
  
    if (icon) {
      gsap.fromTo(
        icon,
        duration,
        { y: 50, ease: Power2.easeOut, opacity: 0, scaleY: 0.7 },
        { y: 0, ease: Power2.easeOut, opacity: 1, scaleY: 1 }
      );
    }
  
    gsap.utils.toArray(spans).forEach((span, index) => {
      gsap.fromTo(
        span,
        duration,
        { y: 50, ease: Power2.easeOut, opacity: 0, scaleY: 0.7 },
        {
          y: 0,
          ease: Power2.easeOut,
          opacity: 1,
          scaleY: 1,
          delay: 0.1 * index, // 如果需要缩短延迟时间，也可以修改此处的系数
        }
      );
    });
  
    if (spans.length) {
      spans[0].classList.add("animated");
    }
  }

  export const scrollAnimateCustom = {
    inserted: function (el, binding) {
      el.addEventListener("mouseenter", function () {
        animateTextCustom(el, binding.value);
      });
    },
  };


// WEBPACK FOOTER //
// ./src/utils/newFontAnimate.js